import { render } from "./form4.vue?vue&type=template&id=0cfacaca&scoped=true&ts=true"
import script from "./form4.vue?vue&type=script&lang=ts"
export * from "./form4.vue?vue&type=script&lang=ts"

import "./form4.vue?vue&type=style&index=0&id=0cfacaca&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cfacaca"]])

export default __exports__